import { Text, TextProps } from '@chakra-ui/react';
import { ExternalLink } from './ExternalLink';

export function TermsOfUseNotification(props: TextProps) {
  return (
    <Text color="#a9a9a9" fontSize="12px" {...props}>
      Ao continuar você está de acordo com nossos{' '}
      <ExternalLink style={{ textDecoration: 'underline' }} to="/legal/termos-de-uso">
        Termos de Uso
      </ExternalLink>
    </Text>
  );
}
